'use client';

import { useState } from 'react';

import { InterlinkingItem } from '@core/Entities/Location/RegionArea.entity';
import Button from '@gds/Button/Button';

import { InterlinkingRegionItem } from '../InterlinkingRegionItem/InterlinkingRegionItem';

import styles from './LocationInterlinking.module.css';

export const LocationInterlinkingMobileView = ({
  interlinkingItem,
  viewMoreCtaText,
}: {
  interlinkingItem: InterlinkingItem;
  viewMoreCtaText: string;
}) => {
  const [shouldShowAll, setShouldShowAll] = useState(false);

  const handleViewMore = () => {
    setShouldShowAll(true);
  };

  return (
    <ul className={`${styles.locationLayout} ${styles.mobileView}`}>
      {interlinkingItem.regions
        .slice(0, shouldShowAll ? interlinkingItem.regions.length : 3)
        .map(region => (
          <InterlinkingRegionItem key={region.name} region={region} />
        ))}
      {!shouldShowAll && interlinkingItem.regions && interlinkingItem.regions.length > 3 && (
        <Button variant="link" className={styles.viewMore} onClick={handleViewMore}>
          {viewMoreCtaText}
        </Button>
      )}
    </ul>
  );
};
